import React, { memo, useEffect, useRef, useState } from "react"
import PropTypes from 'prop-types'
import Options from './components/Options'
import useSelect from './useSelect'
import classes from "./classes";

const SelectSearch = React.forwardRef(({
    multiple, closeOnSelect, disabled, placeholder, search, value,
    fuzzySearch, autoFocus, autoComplete, renderValue, collapseRenderOption, ...hookProps
}, ref) => {
    const selectRef = useRef(null)
    const cls = (classNames) => classes(classNames)

    const [controllValue, setControllValue] = useState(value)
    const [snapshot, valueProps, optionProps] = useSelect({
        value: controllValue,
        placeholder,
        multiple,
        search,
        collapseRenderOption,
        closeOnSelect: closeOnSelect && !multiple,
        useFuzzySearch: fuzzySearch,
        ...hookProps,
    })

    const { highlighted, value: snapValue, fetching, focus } = snapshot;

    const props = {
        ...valueProps,
        autoFocus,
        autoComplete,
        disabled
    };


    useEffect(() => {
        const { current } = selectRef;
        if (current) {
            const val = Array.isArray(snapValue) ? snapValue[0] : snapValue;
            const selected = current.querySelector(
                highlighted > -1
                    ? `[data-index="${highlighted}"]`
                    : `[value="${encodeURIComponent(val)}"]`,
            );

            if (selected) {
                const rect = current.getBoundingClientRect();
                const selectedRect = selected.getBoundingClientRect();

                current.scrollTop =
                    selected.offsetTop -
                    rect.height / 2 +
                    selectedRect.height / 2;
            }
        }
    }, [snapValue, highlighted, selectRef.current]);

    useEffect(() => setControllValue(value), [value])

    console.log(optionProps)
    console.log(props)

    return (
        <div className='select-search-container' >
            <div className='select-search-value' ref={ref}>
                <div className='select-search-input'>
                    <input type='text' {...props} placeholder="Search for trademark, ..." /></div>
                <div className="icon-container" onClick={collapseRenderOption}>
                    <svg height="20" width="20" viewBox="0 0 20 20" aria-hidden="true" focusable="false" className="css-8mmkcg">
                        <path d="M4.516 7.548c0.436-0.446 1.043-0.481 1.576 0l3.908 3.747 3.908-3.747c0.533-0.481 1.141-0.446 1.574 0 0.436 0.445 0.408 1.197 0 1.615-0.406 0.418-4.695 4.502-4.695 4.502-0.217 0.223-0.502 0.335-0.787 0.335s-0.57-0.112-0.789-0.335c0 0-4.287-4.084-4.695-4.502s-0.436-1.17 0-1.615z">
                        </path>
                    </svg>
                </div>
            </div>
            {renderValue && <div className="select-search-select" ref={selectRef} onMouseDown={(e) => { e.preventDefault() }} >
                <Options options={snapshot.options} optionProps={optionProps} snapshot={snapshot} disabled={disabled} />
                {/* <p>You clicked {count} times</p>
            <button onClick={() => setCount(count + 1)}>Click me</button> */}
            </div>}
        </div>)
});

SelectSearch.defaultProps = {
    options: [],
    fuzzySearch: true,
    printOptions: 'auto',
    closeOnSelect: true,
    debounce: 250,
    // Attributes
    autoComplete: 'on',
    // Design
    className: 'select-search',
}

SelectSearch.propTypes = {
    options: PropTypes.arrayOf(
        PropTypes.shape({
            name: PropTypes.string.isRequired,
            value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]).isRequired,
        })
    ),
    collapseRenderOption: PropTypes.func,
    getOptions: PropTypes.func,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    defaultValue: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    search: PropTypes.bool,
    disabled: PropTypes.bool,
    debounce: PropTypes.number,
    className: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    placeholder: PropTypes.string,
    id: PropTypes.string,
    onChange: PropTypes.func,
    onfocus: PropTypes.func,
    onBlur: PropTypes.func
}

SelectSearch.displayName = 'Select product';

export default memo(SelectSearch)